module.exports = __webpack_public_path__ + "assets/img/btn-back-325ed07d.png";